import { Component, inject, signal, WritableSignal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { ButtonComponent } from '../../components/button/button.component';
import TYPES from '../../constants/types';
import { Psychologist } from '../../models/psychologists';
import { Router } from '@angular/router';
import { LogService } from '../../services/log.service';
import { Log } from '../../models/log';
import { LogShared } from '../../models/log-shared';
import { AUTH_SERVICE, AuthService } from '../../services/auth.service';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { LogSharedService } from '../../services/log-shared.service';
import { UserPsychologistService } from '../../services/user-psychologist.service';
import { UserPsychologist } from '../../models/user-psychologist';
import { LoadingComponent } from '../../components/loading/loading.component';

@Component({
  selector: 'app-share-log',
  imports: [
    ButtonComponent,
    TranslatePipe,
    ReactiveFormsModule,
    MatIcon,
    MatRippleModule,
    MatSnackBarModule,
    LoadingComponent
  ],
  templateUrl: './share-log.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './share-log.component.scss'
})
export class ShareLogComponent {

  BUTTON_TYPES: any;
  
  loading: WritableSignal<boolean> = signal(false);
  activeUserPsychologist: WritableSignal<UserPsychologist | null> = signal<UserPsychologist | null>(null);
  userPsychologistService: UserPsychologistService<UserPsychologist> = inject(UserPsychologistService);

  logSharedService: LogSharedService<LogShared> = inject(LogSharedService);
  logService: LogService<Log> = inject(LogService);
  authService: AuthService = inject(AUTH_SERVICE);
  snackBar:MatSnackBar = inject(MatSnackBar);
  translate: TranslateService = inject(TranslateService);

  sharedLog: LogShared | undefined;

  constructor(private router:Router){

    this.loading.set(true);
    this.logSharedService.getShareLogByLogId(this.logService.log().id || '').then(
      (data) => {
        this.sharedLog = data;

        const userId = this.authService.user()?.id;
        console.log(userId);
        if(userId){
          this.userPsychologistService.getActiveUserPsychologist(userId).then(
            (data) => {
              this.activeUserPsychologist.set(data);
              this.loading.set(false);
            }
          );
        }else{
          this.loading.set(false);
        }    
    });
    
    this.BUTTON_TYPES = TYPES.UI.BUTTON;
  }

  async share(){
    if(this.activeUserPsychologist()){    
      if(!this.sharedLog){
        const logShared: Partial<LogShared> = {
          log_id: this.logService.log().id,
          psychologist_id: this.activeUserPsychologist()?.psychologists?.id,
          user_id: this.authService.user()?.id
        }
        await this.logSharedService.create(TYPES.DATABASE.TABLES.LOGS_SHARED, logShared);        
      }

      this.logService.resetLogState();

      const message:string = this.translate.instant('info.shared');
      const action:string = this.translate.instant('buttons.dismiss');
      this.snackBar.open(message, action);

      this.router.navigate(['/home'], { replaceUrl: true });
    }    
  }

  async skip(){
    if(this.sharedLog){
      if(this.sharedLog.id){
        await this.logSharedService.delete(TYPES.DATABASE.TABLES.LOGS_SHARED, this.sharedLog.id);
      }
    }
    this.logService.resetLogState();
    this.router.navigate(['/home'], { replaceUrl: true });
  }

}
